<template>
  <div>
    <div ref="jsoneditor" class="json-editor-container"></div>
  </div>
</template>

<script>
import { createJSONEditor } from 'vanilla-jsoneditor'
export default {
  name: 'JsonEditor',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: [Object, Array, String],
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      editor: null
    }
  },
  // watch: {
  //   value: {
  //     handler(newVal) {
  //       if (!this.editor) return;
  //       this.editor.updateProps({
  //         content: { json: newVal }
  //       })
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    updateContent(content) {
      if(!this.editor) return;
      this.editor.updateProps({
        content: { json: content }
      })
    },
    getContent() {
      if(!this.editor) return null
      return this.editor.get().json
    }
  },
  mounted() {
    this.editor = createJSONEditor({
      target: this.$refs.jsoneditor,
      props: {
        mode: 'text',
        navigationBar: false,
        mainMenuBar: false,
        readOnly: this.disabled,
        content: {
      text: this.value
    },
        onChange: (updatedContent, previousContent, { contentErrors, patchResult }) => {
          const updated_text = updatedContent.text
          this.$emit('input', updated_text)
          this.$emit('change', updated_text)
          
        }
      }
    })
  },
  beforeDestroy() {
    this.editor?.destroy?.()
  },
}
</script>